module.exports = __webpack_public_path__ + "static/media/battleship.8d7d8a42.png";